import React from 'react';

import { Grid, makeStyles, Typography } from '@material-ui/core';

import CaseActionsArchiveButton from './CaseActionsArchiveButton';
import CaseActionsGiveOnlinePortalAccess from './CaseActionsGiveOnlinePortalAccess';
import CaseActionsRadiologyImagesField from './CaseActionsRadiologyImagesField';
import CaseActionsRadiologyReportField from './CaseActionsRadiologyReportField';
import CaseActionsSharedImage from './CaseActionsSharedImage';
import { caseStatuses } from '../../models/Case';
import CustomColorButton from '../common/CustomColorButton';
import LoadingButton from '../common/LoadingButton';

const useStyles = makeStyles(() => {
  return {
    rejectCaseButton: {
      marginTop: '1.25rem',
    },
    sectionHeader: {
      color: '#172B4D',
      fontSize: '18px',
      fontWeight: 'bold',
      marginBottom: '1rem',
    },
    sectionText: {
      color: '#999999',
      fontSize: '12px',
      marginTop: '1rem',
    },
    submitMediphanyButton: {
      marginTop: '3rem',
    },
  };
});

export default ({
  fileStatus,
  onCaseAction,
  auth,
  isSubmitting$,
  isSubmitting,
  caseStatus,
  hideFileControls,
  onChangeTitle,
  onRemoveFiles,
  onFileChange,
  onRemoveSharedImage,
  onGiveOnlinePortalAccess,
  loadingSharedImageDetail,
  onSelectSharedImage,
  onViewSharedImage,
  onRemoveReport,
  onReportChange,
  onOpenRadiologyReportDialog,
  isArchiving$,
  isWhiteGloveWorkspace,
  uploadSharedInfo,
  workspaceMainFileType,
  onOpenImageSelectionDialog,
  radiologyReportRequired,
}) => {
  const classes = useStyles();
  let submitButtonEnabled =
    (fileStatus.existingStudy && ((fileStatus.uploadedReport && fileStatus.uploadedReport.length > 0) || fileStatus.hasReport)) ||
    (fileStatus.reportUploaded && fileStatus.uploaded && fileStatus.imageCount) ||
    (fileStatus.sharedImageSelected && fileStatus.reportUploaded) ||
    (uploadSharedInfo?.portalAddress && uploadSharedInfo?.portalPassword && uploadSharedInfo?.portalUsername && uploadSharedInfo?.studyName);

  if (!radiologyReportRequired) {
    submitButtonEnabled =
      fileStatus.existingStudy ||
      fileStatus.imageCount ||
      fileStatus.sharedImageSelected ||
      (uploadSharedInfo?.studyName && uploadSharedInfo?.portalAddress && uploadSharedInfo?.portalPassword && uploadSharedInfo?.portalUsername);
  }

  const isMediphanyWorkspace = auth?.workspace?.isMediphanyWorkspace && auth?.workspaceId === caseStatus?.data?.workspaceId;
  const shouldShowPortalUploadButton = caseStatus?.status === caseStatuses['pending-upload'].value && isWhiteGloveWorkspace;

  return (
    <Grid container className="text-left">
      <Grid item xs={12}>
        <Typography className={classes.sectionHeader}>Upload Study</Typography>
        <Typography className={classes.sectionText}>The patient has requested that the scan images be uploaded on their behalf.</Typography>
      </Grid>
      <Grid item xs={12}>
        <CaseActionsRadiologyImagesField
          fileStatus={fileStatus}
          hideFileControls={hideFileControls}
          onChangeTitle={onChangeTitle}
          onRemoveFiles={onRemoveFiles}
          onFileChange={onFileChange}
          shouldSelectAnyStudy={workspaceMainFileType === 'any'}
          onOpenImageSelectionDialog={onOpenImageSelectionDialog}
        />
      </Grid>

      <Grid item xs={12}>
        <CaseActionsRadiologyReportField
          fileStatus={fileStatus}
          onReportChange={onReportChange}
          onOpenRadiologyReportDialog={onOpenRadiologyReportDialog}
          onRemoveReport={onRemoveReport}
          isSubmitting={isSubmitting}
        />
      </Grid>

      {!isWhiteGloveWorkspace && (
        <Grid item xs={12}>
          <CaseActionsSharedImage
            fileStatus={fileStatus}
            onRemoveSharedImage={onRemoveSharedImage}
            loadingSharedImageDetail={loadingSharedImageDetail}
            onSelectSharedImage={onSelectSharedImage}
            onViewSharedImage={onViewSharedImage}
          />
        </Grid>
      )}

      {shouldShowPortalUploadButton && (
        <Grid item xs={12}>
          <CaseActionsGiveOnlinePortalAccess onGiveOnlinePortalAccess={onGiveOnlinePortalAccess} />
        </Grid>
      )}

      <Grid item xs={12}>
        <LoadingButton
          loading$={isSubmitting$}
          disabled={isSubmitting || !submitButtonEnabled}
          variant="contained"
          fullWidth
          component="span"
          onClick={() => onCaseAction('submitClinicUpload')}
          className={classes.submitMediphanyButton}
          color="primary">
          Submit to Mediphany
        </LoadingButton>
        {!isMediphanyWorkspace && (
          <CustomColorButton
            bgColor="#FFF"
            borderColor="#B12A2A"
            className={classes.rejectCaseButton}
            onClick={() => onCaseAction('rejectPendingUpload')}
            txtColor="#B12A2A"
            variant="outlined"
            fullWidth
            disabled={isSubmitting}
            component="span">
            Reject Case
          </CustomColorButton>
        )}
      </Grid>
      <Grid item xs={12}>
        <div style={{ marginTop: '1rem' }}>
          <CaseActionsArchiveButton fullWidth size="medium" auth={auth} isArchiving$={isArchiving$} onCaseAction={onCaseAction} />
        </div>
      </Grid>
    </Grid>
  );
};
